export enum ColorScheme {
  BRIGHT = 'BRIGHT',
  DARK = 'DARK',
}
